import React, {useEffect, useMemo, useState} from 'react';
import {Card, Col, Row, Space, Tabs, Typography} from "antd";
import usePortfoliosCollection from "../Portfolio/PortfoliosCollection/usePortfoliosCollection";
import Cheatsheet from "../Portfolio/Cheatsheet";

const PortfolioViewsLauncher = ()=>{
    const { formattedPortfolios } = usePortfoliosCollection();

    return (
        <Tabs centered={true}>
            <Tabs.TabPane key={'1'} tab={'Cheatsheet'}>
                <Cheatsheet portfolios={formattedPortfolios} />
            </Tabs.TabPane>
        </Tabs>
    )

}

export default PortfolioViewsLauncher;